<template>
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card title="Warehouse Stock Transfer" class="p-4 mb-6">
                <div
                    slot="header"
                    class="flex flex-wrap items-center justify-between"
                >
                    <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
                        <h4>Warehouse Stock Transfer</h4>
                    </div>
                    <div
                        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                    >
                        <vs-button
                            color="primary"
                            class="mb-4 mr-1 btn md:mb-0"
                            @click="submitForm"
                            >Process</vs-button
                        >
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <label class="vs-input--label"
                            ><b>Source Location ID</b></label
                        >
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <vs-select
                            class="selectExample"
                            v-model="form.source_location_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, location)"
                        >
                            <vs-select-item
                                v-for="(item, index) in location.data"
                                :key="index"
                                :value="item.id"
                                :text="item.location_code"
                            />
                        </vs-select>
                    </div>
                </div>

                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <label class="vs-input--label"
                            ><b>Destination Location ID</b></label
                        >
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <vs-select
                            class="selectExample"
                            v-model="form.destination_location_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, location)"
                        >
                            <vs-select-item
                                v-for="(item, index) in location.data"
                                :key="index"
                                :value="item.id"
                                :text="item.location_code"
                            />
                        </vs-select>
                    </div>
                </div>

                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <label class="vs-input--label"><b>Product ID</b></label>
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <vs-select
                            class="selectExample mb-2"
                            v-model="form.product_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, product)"
                        >
                            <vs-select-item
                                v-for="(item, index) in product.data"
                                :key="index"
                                :value="item.id"
                                :text="item.product_code"
                            />
                        </vs-select>
                    </div>
                </div>

                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <label class="vs-input--label"
                            ><b>Stock Type ID</b></label
                        >
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <vs-select
                            class="selectExample mb-2"
                            v-model="form.stock_type_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, stock_type)"
                        >
                            <vs-select-item
                                v-for="(item, index) in stock_type.data"
                                :key="index"
                                :value="item.id"
                                :text="item.name"
                            />
                        </vs-select>
                    </div>
                </div>

                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <label class="vs-input--label"><b>Base Qty</b></label>
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col md:w-1/4">
                        <vs-input
                            class="w-full"
                            label="Base Qty"
                            v-model="form.base_qty"
                        />
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    data() {
        return {
            isLoading: false,
            isForm: false,
            file: null,
            fileName: "Select file (.xslx, .xls)",
            location: {
                data: [],
                loading: false,
                endpoint: "master/locations",
                objectKey: "location_code",
            },
            form: {
                source_location_id: null,
                destination_location_id: null,
                product_id: null,
                stock_type_id: null,
                base_qty: 0,
            },
            product: {
                data: [],
                loading: false,
                endpoint: "master/product",
                objectKey: "product_code",
            },
            stock_type: {
                data: [],
                loading: false,
                endpoint: "master/stocktypes",
                objectKey: "name",
            },
        };
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        // submitForm() {
        //   if(this.reference == ''){
        //     this.$vs.notify({
        //           color: "danger",
        //           title: "Error",
        //           text: "No Reference is required"
        //       });

        //       return false;
        //   }
        //   this.isLoading = true;
        //   this.$http.post("support/resend_awb_confirm_status", {
        //       reference: this.reference
        //   })
        //   .then(res => {
        //       this.isLoading = false;
        //       const message = res.data.message ? res.data.message : 'Success.'
        //       this.$vs.notify({
        //           color: "success",
        //           title: "Success",
        //           iconPack: "feather",
        //           icon: "icon-check",
        //           text: message
        //       });

        //       setTimeout(() => {
        //           window.location.reload()
        //       }, 200);
        //   })
        //   .catch(error => this.handleError(error));
        // },
        submitForm() {
            this.isLoading = true;

            this.$http
                .post("support/warehouse_stock_transfer", this.form)
                .then((res) => {
                    this.isLoading = false;
                    const message = res.data.message
                        ? res.data.message
                        : "Success.";
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message,
                    });

                    setTimeout(() => {
                        //window.location.reload()
                    }, 200);
                })
                .catch((error) => this.handleError(error));
        },
    },
    mounted() {},
};
</script>
